<template>
  <div :class="['app-alerts', alerts.length ? 'mt-2' : '']">
    <FlashMessage
      v-for="(alert) in alerts"
      :key="alert.id"
      :show="true"
      :message="['__nonEditable__', '__nonEditableFlagship__'].includes(alert.message) ? 'slot' : alert.message"
      :type="alert.type"
      :this-page-only="alert.thisPageOnly"
      @close="$emit('closeAlert', alert.id)"
    >
      <template v-if="alert.message === '__nonEditable__'">
        This job is no longer editable.&nbsp;
        <span v-if="!alert.params.hideNewDraftLink">
          <span
            class="create-draft-link"
            @click="$emit('showDuplicateModal')"
          >
            Create a draft
          </span> to update content.
        </span>
      </template>
      <template v-if="alert.message === '__nonEditableFlagship__'">
        Flagship jobs are read only.&nbsp;
        <span v-if="!alert.params.hideNewDraftLink">
          <span
            class="create-draft-link"
            @click="duplicateFlagship"
          >
            Duplicate the job
          </span> to create an editable draft.
        </span>
      </template>

      <template v-if="alert.message === '__integrationTapwageNonEditable__'">
        You don't have permission to edit this {{ alert.params.jobStatus || '' }} post.&nbsp;
        <span v-if="!alert.params.hideNewDraftLink">
          Would you like to
          <span
            class="create-draft-link"
            @click="$emit('showDuplicateModal')"
          >
            duplicate it
          </span> instead?
        </span>
      </template>
    </FlashMessage>
  </div>
</template>

<script>
import FlashMessage from '@/components/shared/alerts/FlashMessage.vue';
import { useTracking } from '@/stores/tracking/tracking';

export default {
  name: 'AppAlerts',
  components: { FlashMessage },
  props: {
    alerts: { type: Array, default: () => [] },
  },
  emits: ['closeAlert', 'showDuplicateModal'],
  methods: {
    duplicateFlagship() {
      this.$emit('showDuplicateModal');
      useTracking().flagshipDuplicate({ origin: 'Acknowledgements banner' });
    },
  },
};
</script>

<style lang="less" scoped>
.app-alerts {
  padding: 0 32px;
  margin: 0 auto;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 5;
}
.create-draft-link {
  color: @white;
  text-decoration: underline;
  cursor: pointer;
}
</style>
